import { DadosFichaCrediario } from "app/components/ficha-crediario-cliente/FichaCrediarioCliente";
import { DadosFichaFinanceira, FiltroFichaFinanceira } from "app/components/ficha-financeira/FichaFinanceiraCliente";
import { FiltroOrcamentoAberto } from "app/types/cliente/FiltroOrcamentoAberto";
import { FiltroPesquisaClientes } from "app/types/cliente/FiltroPesquisaClientes";
import { PesquisaClienteConsultasPadrao } from "app/types/cliente/PesquisaClienteConsultasPadrao";
import { RespostaAcompanhamentos } from "app/types/cliente/RespostaAcompanhamentos";
import { RespostaCadastroCliente } from "app/types/cliente/RespostaCadastroCliente";
import { DataFormatoPT } from "app/types/DataFormatoPT";
import { ICliente } from "app/types/ICliente";
import { RespostaCredito } from "app/types/cliente/RespostaCredito";
import { RespostaDocumentosAbertos } from "app/types/cliente/RespostaDocumentosAbertos";
import { RespostaDocumentosQuitados } from "app/types/cliente/RespostaDocumentosQuitados";
import {
  DadosOrcamentoEmAberto, OrcamentoEmAbertoForm
} from "../../components/pesquisa-cliente/pendencia-cliente/orcamentoEmAberto/OrcamentoEmAberto";
import { RespostaLimiteCredito, RespostaListarHistoricoLimiteCredito } from "app/types/cliente/RespostaLimiteCredito";
import { RespostaOrcamentoAbertos } from "app/types/cliente/RespostaOrcamentosAbertos";
import { RespostaUltimasCompras } from "app/types/cliente/RespstaUltimasCompras";
import { PagedMessageResponse } from "../types/PagedMessageResponse";
import { BaseApi } from "./BaseApi";
import { IEstado } from "app/types/IEstado";

import { CadastroAtendimento } from "../../components/atendimento/CadastrarAtendimento/CadastrarAtendimento";
import { ComissoesEndereco } from "app/types/ComissoesEndereco";
import { Vendedor } from "app/types/Vendedor";
import { DadosCashback } from "app/components/cashback/Cashback";
import { DadosGuiaClienteContract } from "app/components/pesquisa-cliente/dados-cliente/DadosCliente";

export class ClienteApi extends BaseApi {
  async pesquisar(filtro: FiltroPesquisaClientes): Promise<PagedMessageResponse<ICliente>> {
    const resposta = await this.api.post(`/Cliente/Pesquisar`, filtro);

    return resposta.data;
  }

  async obterDadosFichaFinanceira(pesquisa: FiltroFichaFinanceira): Promise<DadosFichaFinanceira> {
    const resposta = await this.api.post(`/Cliente/ObterDadosFichaFinanceira`, { pesquisa })
    return resposta.data
  }

  async obterDadosPesquisar(identificador: string): Promise<any> {
    const resposta = await this.api.post(
      `/Cliente/ObterDadosPesquisar`,
      identificador
    );

    return resposta.data;
  }

  async obterDadosTelaCliente(identificadorOrcamento: string, consultar?: boolean): Promise<DadosTelaCliente> {
    const resposta = await this.api.post(`/Cliente/ObterDadosTelaCliente`, {
      identificadorOrcamento,
      consultar
    });

    return resposta.data;
  }

  async salvar(cliente: ICliente): Promise<ICliente> {
    const resposta = await this.api.post("/Cliente/Salvar", {
      cliente
    })
    return resposta.data
  }

  async CadastrarAtendimento(dados: CadastroAtendimento): Promise<boolean> {
    const resposta = await this.api.post('/AtendimentoCliente/Salvar', {
      salvarContract: dados
    })
    return resposta?.data;
  }

  async ListarDocumentosQuitados(codigoCliente: number, tamanhoPagina: number, numeroPagina: number = 1, colunaOrdenacao?: string, decrescente?: boolean): Promise<RespostaDocumentosQuitados> {
    const { data } = await this.api.post(`/Cliente/ListarDocumentosQuitados`, {
      filtros: {
        OidCliente: codigoCliente,
        TamanhoPagina: tamanhoPagina,
        NumeroPagina: numeroPagina
      },
      colunaOrdenacao,
      decrescente
    });

    return data
  }
  async ObterValorTotalDocumentosQuitados(codigoCliente: number): Promise<number> {
    const { data } = await this.api.post(`/Cliente/ObterValorTotalDocumentosQuitados`, {
      OidCliente: codigoCliente,
    });

    return data
  }

  async alterarFonte(tamanho: number): Promise<void> {
    const response = await this.api.post(`/Usuario/TamanhoFonteGrid`, {
      tamanho,
      idGrid: 6,
    });
    return response.data;
  }

  async ObterDadosCadastroCliente(codigoCliente: number, identificadorOrcamento: string, forcarAtualizar: boolean = false): Promise<any> {
    const resposta = await this.api.post(`/Cliente/ObterDadosCadastroCliente`, {
      codigoCliente,
      identificadorOrcamento,
      forcarAtualizar //440006
    });
    return resposta.data;
  }

  async cadastroClienteNaoCadastrado(
    identificadorOrcamento: string
  ): Promise<ICliente> {
    const resposta = await this.api.post(`/Cliente/CadastroClienteNaoCadastrado`, {
      identificadorOrcamento,
    });
    return resposta.data;
  }

  async dadosEditarEndereco(numeroCpfCnpj: string, clienteNaoCadastrado: boolean = false): Promise<ComissoesEndereco> {
    const response = await this.api.post("/Cliente/DadosEditarEndereco", {
      numeroCpfCnpj,
      clienteNaoCadastrado,
    });
  
    return response.data;
  }

  async BuscarFichaCrediario(codigoCliente: number): Promise<DadosFichaCrediario[]> {
    const { data } = await this.api.post(`/Cliente/BuscarFichaCrediario`, { 'codigoCliente': codigoCliente })

    const dadosFichaCrediario: DadosFichaCrediario[] = data?.DadosFichaCrediario || []

    return dadosFichaCrediario
  }

  async filtrarOrcamentosEmAberto(filtros: OrcamentoEmAbertoForm): Promise<{
    Entities: DadosOrcamentoEmAberto[],
    ActualPage: number,
    IsLastPage: false,
    PageCount: number,
    PageSize: number,
    RowsCount: number,
    StartIndex: number,
  }> {
    const { data } = await this.api.post(`/Orcamento/ListarPedidosEmAberto`, { filtros })
    return data
  }

  async SalvarFichaCrediario(codigoCliente: number, dadosFichaCrediario: any): Promise<boolean> {
    const { data } = await this.api.post(`/Cliente/SalvarFichaCrediario`, { 'codigoCliente': codigoCliente, 'dadosFichaCrediario': dadosFichaCrediario })
    return data
  }

  async DadosDocumentoAberto(pesquisa: PesquisaClienteConsultasPadrao, colunaOrdenacao?: string, ordenacaoDecrescente?: boolean): Promise<RespostaDocumentosAbertos> {
    const { data } = await this.api.post(`/Cliente/DadosDocumentoAberto`, { pesquisa, colunaOrdenacao, ordenacaoDecrescente })

    return data
  }

  async DadosAcompanhamento(pesquisa: PesquisaClienteConsultasPadrao): Promise<RespostaAcompanhamentos> {
    const { data } = await this.api.post(`/Cliente/DadosAcompanhamento`, { pesquisa })

    return data
  }

  async DadosOrcamentoAberto(pesquisaOrcamentoAbertoContract: FiltroOrcamentoAberto, colunaOrdenacao?: string, ordenacaoDecrescente?: boolean): Promise<RespostaOrcamentoAbertos> {
    const { data } = await this.api.post(`/Cliente/DadosOrcamentoAberto`, { pesquisaOrcamentoAbertoContract, colunaOrdenacao, ordenacaoDecrescente })
    return data
  }

  async ObterDadosCashbackCliente(oidCliente: number): Promise<Partial<DadosCashback>> {
    const { data } = await this.api.post(`/Cliente/ObterDadosCashbackCliente`, { oidCliente })
    return data
  }

  async LimiteCredito(pesquisa: PesquisaClienteConsultasPadrao): Promise<RespostaLimiteCredito> {
    const { data } = await this.api.post(`/Cliente/LimiteCredito`, { pesquisa })
    return data
  }

  async ListarHistoricoLimiteCredito(filtros: PesquisaClienteConsultasPadrao): Promise<RespostaListarHistoricoLimiteCredito> {
    const { data } = await this.api.post(`/Cliente/ListarHistoricoLimiteCredito`, { filtros })
    return data
  }

  async Credito(pesquisa: PesquisaClienteConsultasPadrao): Promise<RespostaCredito> {
    const { data } = await this.api.post(`/Cliente/Credito`, { pesquisa })
    return data
  }

  async listarCreditosCliente(pesquisa: PesquisaClienteConsultasPadrao, colunaOrdenacao?: string, ordenacaoDecrescente?: boolean): Promise<RespostaCredito> {
    const { data } = await this.api.post(`/Cliente/ListarCreditosCliente`, { pesquisa, colunaOrdenacao, ordenacaoDecrescente })
    return data
  }

  async DadosUltimasCompras(codigoCliente: number, tamanhoPagina: number): Promise<RespostaUltimasCompras> {
    const { data } = await this.api.post(`/Cliente/DadosUltimasCompras`, { codigoCliente, tamanhoPagina })
    return data
  }

  async UltimasCompras(codigoCliente: number, tamanhoPagina: number): Promise<PagedMessageResponse<ClienteApi.ListarComprasResposta>> {
    return (await this.api.get(`/Cliente/UltimasCompras`, {
      params: {
        codigoCliente,
        tamanhoPagina
      }
    })).data

  }

  async ListarCompras(filtros: ClienteApi.ListarComprasRequisicao): Promise<PagedMessageResponse<ClienteApi.ListarComprasResposta>> {
    return (await this.api.post(`/Cliente/ListarCompras`, { filtros })).data
  }

  async obrigatorioInformarEmail(numeroCpfCnpj: string): Promise<boolean> {
    return (await this.api.post(`/Cliente/ObrigatorioInformarEmail`, { numeroCpfCnpj })).data
  }

  async obterDadosGuiaCliente(oidCliente: number, identificadorOrcamento: string): Promise<DadosGuiaClienteContract> {
    const { data } = await this.api.post(`/Cliente/ObterDadosGuiaCliente`, { oidCliente, identificadorOrcamento })
    return data
  }
}

export namespace ClienteApi {

  export type ListarComprasResposta = {
    DataVenda?: string;
    ReferenciaProduto?: string;
    CodigoProduto?: string;
    DescricaoProduto?: string;
    Lote?: string;
    LoteReserva?: string;
    LoteSaida?: string;
    NomeBitola?: string;
    NomeBitolaReserva?: string;
    NomeBitolaSaida?: string;
    NomeTonaliadeReserva?: string;
    NomeTonaliadeSaida?: string;
    NomeTonalidade?: string;
    NomeVendedor?: string;
    NumeroPedido?: number;
    Preco?: number;
    Quantidade?: number;
    QuantidadeItemReservaLote?: number
    QuantidadeItemSaidaLote?: number
    ValidadeLote?: string
    ControleValidadeLote?: number
    LoteVencido?: boolean;
    QtdeItemSaidaLote?: number;
    QuantidadeLote?: number;
    QuantidadeReservaLote?: number
    QuantidadeSaidaLote?: number
  }

  export type ListarComprasRequisicao = {
    CodigoCliente?: number;
    CodigosProdutos?: string[];
    DataFinal?: DataFormatoPT;
    DataInicial?: DataFormatoPT;
    CodigoProduto?: string;
    ReferenciaProduto?: string;
    DescricaoProduto?: string;
    ClasseProduto?: string;
    CodigoFornecedor?: string;
    NumeroPagina?: number
    TamanhoPagina?: number
  }
}

export type DadosTelaCliente = {
  VendedorLogado: Vendedor
  UsuarioPermitidoAlterarVendedorRelacionado: boolean
  Estados: IEstado[]
  Orcamento: string
  Cliente: ICliente
}
